var _path, _path2, _path3;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgChartLine = function SvgChartLine(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.608 2.5 2.5 15a1.667 1.667 0 0 0 1.667 1.667h12.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.18 5.417-4.617 4.618-2.43-2.43-3.647 3.645"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.264 5.417h2.916v2.917"
  })));
};
export { SvgChartLine as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuNjA4MzMgMi41TDIuNSAxNUMyLjUgMTUuNDQyIDIuNjc1NTkgMTUuODY2IDIuOTg4MTYgMTYuMTc4NUMzLjMwMDcyIDE2LjQ5MTEgMy43MjQ2NCAxNi42NjY3IDQuMTY2NjcgMTYuNjY2N0gxNi42NjY3IiAvPgo8cGF0aCBkPSJNMTYuMTgwOCA1LjQxNjk5TDExLjU2MjcgMTAuMDM1TDkuMTMyMTYgNy42MDQ0OUw1LjQ4NjMzIDExLjI1MDMiIC8+CjxwYXRoIGQ9Ik0xMy4yNjM3IDUuNDE2OTlIMTYuMTgwM1Y4LjMzMzY2IiAvPgo8L3N2Zz4K";